import { createSlice } from '@reduxjs/toolkit';
import {
  IAdhocActionResponse,
  IAdhocActionResponseNew,
  IInvalidField,
  IPolicy,
  IPolicyPreviewResponse,
  PolicyType,
} from 'shared';

export interface IAdhocActionModal {
  type?: PolicyType;
  show: boolean;
  currentPolicy?: IPolicy;
  currentPolicyForm?: IPolicy;
  contactId?: number;
  contactName?: string;
  /** Adhoc statement only: which contact persons to send to. Undefined until seeded from the contact */
  contactPersonIds?: string[];
  invoiceId?: string;
  invoiceNumber?: string;
  result?: IAdhocActionResponse;
  /** The new result for bulk, but goal is to replace the main result to keep it generic */
  resultNew?: IAdhocActionResponseNew;
  preview?: IPolicyPreviewResponse;
  previewError?: string;
  view: `preview` | `result`;
  previewLoading?: boolean;
  applyLoading?: boolean;
  updatePolicyLoading?: boolean;
  isBulk?: boolean;
  invoiceIds?: string[];
  contactIds?: number[];
  isAnnouncement?: boolean;
  /** Bulk only: the server leaves out frozen, queried and promised invoices */
  checkChaseable?: boolean;
  /** Validation errors from the last apply/preview attempt. Lives in the store so every component using the hook sees them */
  invalids: IInvalidField[];
}

export const initialState: IAdhocActionModal = {
  type: undefined,
  show: false,
  contactId: undefined,
  contactName: undefined,
  contactPersonIds: undefined,
  invoiceId: undefined,
  invoiceNumber: undefined,
  currentPolicyForm: undefined,
  currentPolicy: undefined,
  result: undefined,
  resultNew: undefined,
  preview: undefined,
  previewError: undefined,
  view: `result`,
  previewLoading: false,
  applyLoading: false,
  updatePolicyLoading: false,
  isBulk: false,
  invoiceIds: undefined,
  contactIds: undefined,
  isAnnouncement: false,
  checkChaseable: false,
  invalids: [],
};

const adhocActionModalSlice = createSlice({
  name: `adhocActionModal`,
  initialState,
  reducers: {
    setState(state, action) {
      Object.assign(state, action.payload);
    },
    reset(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { setState, reset } = adhocActionModalSlice.actions;

export const adhocActionModalReducer = adhocActionModalSlice.reducer;
